import { render, staticRenderFns } from "./options-criteria-color-item.vue?vue&type=template&id=44aa77d2&"
import script from "./options-criteria-color-item.vue?vue&type=script&lang=js&"
export * from "./options-criteria-color-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports